module.exports = __webpack_public_path__ + "assets/img/restart2.bd51126c.png";